export function useBodyClass (className: string): Ref<boolean> {
	const classEnabled = ref(false);

	watch(classEnabled, enabled => {
		if (enabled) {
			incrementClassEnabledCount(className);
		}
		else {
			decrementClassEnabledCount(className);
		}
	});

	onBeforeUnmount(() => {
		if (classEnabled.value) {
			decrementClassEnabledCount(className);
		}
	});

	return classEnabled;
}

function incrementClassEnabledCount (className: string): void {
	const currentCount = enabledCountPerClass.get(className) ?? 0;
	enabledCountPerClass.set(className, currentCount + 1);

	if (currentCount === 0) {
		document.body.classList.add(className);
	}
}

function decrementClassEnabledCount (className: string): void {
	const currentCount = enabledCountPerClass.get(className) ?? 0;

	if (currentCount > 1) {
		enabledCountPerClass.set(className, currentCount - 1);
	}
	else {
		enabledCountPerClass.delete(className);
		document.body.classList.remove(className);
	}
}

const enabledCountPerClass = new Map<string, number>();
